// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDesignation_importCsvCard__hxTPa","addDesignationBtnContainer":"AddDesignation_addDesignationBtnContainer__89AyR"};